import * as React from 'react';

import { useOfferTypeFilter } from './hooks/useOfferTypeFilter';
import { IOfferTypeFilterProps } from './types';
import { Select, Option } from '../../Select';

export const OfferType: React.FC<IOfferTypeFilterProps> = ({ dealType, value, onChange: onChangeProp }) => {
  const { offerTypes, offerTypeLabel, selectedOptions, onChange } = useOfferTypeFilter({
    dealType,
    value,
    onChange: onChangeProp,
  });

  return (
    <Select
      data-name="FilterOfferType"
      multiple
      withoutArrow
      label={offerTypeLabel || undefined}
      placeholder="Тип предложения"
      value={selectedOptions}
      onChange={onChange}
    >
      {offerTypes.map(parts =>
        parts.map(offerType => (
          <Option key={`${offerType.label}_${offerType.value}`} value={offerType.value} marker={offerType.marker}>
            {offerType.label}
          </Option>
        )),
      )}
    </Select>
  );
};
